import React, { useEffect, useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getShifts, deleteShift } from "../api";

const ShiftList1 = ({ id_c }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  const loadData = async () => {
    const result = await getShifts(id_c); // { shifts, total }
    setData(result);
  };

  useEffect(() => {
    loadData();
  }, [id_c]);

  if (!data) return <p>{t("MList1")}</p>;

  const handleEdit = (id_shift) => {
    navigate(`/shifts/${id_shift}/edit`);
  };

  const handleDelete = async (id_shift) => {
    if (!window.confirm(t("¿Eliminar este turno?"))) return;
    await deleteShift(id_c, id_shift);
    await loadData();
  };

  // opcional: mostrar HH:mm si backend devuelve HH:mm:ss
  const fmtTime = (tstr) => (tstr ? String(tstr).slice(0, 5) : "");

  return (
    <div className="box1">
      <div className="box9">
        <button className="button7" onClick={() => navigate("/new_shift")}>
          {t("shifts3")}
        </button>

        <table className="table5">
          <thead>
            <tr>
              <th>{t("shifts1")}</th>
              <th>{t("batchList8")}</th>
              <th>{t("batchList10")}</th>
              <th>{t("shifts2")}</th>
              <th colSpan={2}>{t("actType6")}</th>

            </tr>
          </thead>
          <tbody>
            {(data.shifts || []).map((shift) => (
              <tr key={shift.id_shift}>
                <td>{shift.id_shift}</td>
                <td>{fmtTime(shift.time_begin)}</td>
                <td>{fmtTime(shift.time_end)}</td>
                <td>{shift.observations || "-"}</td>
                <td>
                  <button className="button" onClick={() => handleEdit(shift.id_shift)}>
                    {t("MList7")}
                  </button>
                </td>
                <td>
                  <button className="buttonDel" onClick={() => handleDelete(shift.id_shift)}>
                    {t("MList8")}
                  </button>
                </td>
              </tr>
            ))}
            {(!data.shifts || data.shifts.length === 0) && (
              <tr>
                <td colSpan={6}>{t("Sin turnos")}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShiftList1;
